services.service('DocumentService', [
    'UserService', '$state', 'constants', 'API', 'Utils', 'ErrorService', 'DocumentModel',
    function (UserService, $state, Const, API, Utils, ErrorService, DocumentModel) {
        var self = this;

        self.documents = [];
        self.documentsOther = []; //documents collection of type 'Other'

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'DocumentService',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        this.deleteDocument = function (document) {
            return API.documentDelete(document)
                .then(checkResponse)
                .then(function () {
                    return _.remove(self.documentsOther, {id: document.id});
                });
        };

        this.initDocuments = function() {
            var cleanDocuments = [];

            Const.documentTypes
                .forEach(function (doc) {
                    var document = {
                        id: null,
                        type: doc.id,
                        status: 'new',
                        url: '',
                        category: doc.category,
                        baseCategory: doc.baseCategory
                    };
                    cleanDocuments.push(new DocumentModel(document));
                });

            return API.documents()
                .then(checkResponse)
                .then(function (response) {
                    self.documentsOther = response.documents.filter(function (item) {
                        return item.type === 'Other';
                    }).map(function (item) {
                        item.status = Const.documentToStatuses[item.status];
                        return item;
                    });
                    return response;
                })
                .then(function (response) {
                    return _.uniqBy(response.documents, function (item) {
                        return item.type;
                    });
                })
                .then(function (response) {
                    cleanDocuments.map(function (doc) {
                        var _doc = _.find(response, {type: Const.documentFromTypes[doc.type]});
                        if (_doc) {
                            doc.status = Const.documentToStatuses[_doc.status];
                        }
                    });

                    self.documents = cleanDocuments;
                    return self.documents;
                });
        };

        return this;
    }
]);